import BaseInput from "../../../baseComponents/baseInput.js";
import BaseButton from "../../../baseComponents/baseButton.js";
import BaseParagraph from "../../../baseComponents/baseParagraph.js";
import BaseHyperlink from "../../../baseComponents/baseHyperlink.js";
import { useState, useRef, useEffect } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as loginActions,
  asyncActions as asyncLoginActions,
} from "../../../store/slices/loginSlice.js";
import { useNavigate } from "react-router-dom";
import { asyncActions as countriesAsyncActions } from "../../../store/slices/countriesSlice.js";
import { asyncActions as citiesAsyncActions } from "../../../store/slices/citySlice.js";
import { asyncActions as successAsyncActions } from "../../../store/slices/successSlice.js";
import BaseCheckbox from "../../../baseComponents/baseCheckbox.js";
import useColors from "../../../customHooks/useColors.js";
import BaseDropdown2 from "../../../baseComponents/baseDropdown2.js";
import DataProcessingCheckbox from "../../../components/DataProcessingCheckbox.js";
import ApplicationRulesCheckbox from "../../../components/ApplicationRulesCheckbox.js";
import NotificationsCheckbox from "../../../components/NotificationsCheckbox.js";
import OffersPromotionsCheckbox from "../../../components/OffersPromotionsCheckbox.js";
import { useLocation } from "react-router-dom";

const RegisterView = ({
  title,
  autoRelogin = true,
  afterLoginRoutesPath = [],
}) => {
  const location = useLocation();

  const isWithSocialNetwork = location.state?.isWithSocialNetwork ?? false;
  const code = location.state?.code ?? "";
  const email = location.state?.email ?? "";
  const name = location.state?.name ?? "";
  const surname = location.state?.surname ?? "";
  const tempPass = isWithSocialNetwork ? "tempPass1" : "";
  const socialNetworkId =  location.state?.socialNetworkId;
  const socialNetworkType = location.state?.socialNetworkType;


  ////////////////////////////////////////////////NAVIGATOR
  const navigate = useNavigate();
  ////////////////////////////////////////////////DISPATCHER
  const dispatch = useDispatch();

  ////////////////////////////////////////////////RES
  const emailRef = useRef();

  const [currentColors] = useColors();

  ////////////////////////////////////////////////redux states
  const loginState = useSelector((state) => state.loginState);
  const systemState = useSelector((state) => state.systemState);

  const countriesState = useSelector((state) => state.countriesState);
  const citiesState = useSelector((state) => state.citiesState);

  ////////////////////////////////////////////////LOCAL STATE
  /*Checkboxes*/
  const [acceptRules, setAcceptRules] = useState(
    systemState.settings.init_value_permission1 ?? false
  );
  const [acceptDataProcessing, setAcceptDataProcessing] = useState(
    systemState.settings.init_value_permission2 ?? false
  );
  const [acceptNotifications, setAcceptNotifications] = useState(
    systemState.settings.init_value_permission3 ?? false
  );
  const [acceptOffers, setAcceptOffers] = useState(
    systemState.settings.init_value_permission4 ?? false
  );

  /*Inputs */
  const [emailInput, setEmailInput] = useState(email);
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumberInput, setPhoneNumberInput] = useState("");
  const [passwordInput, setPasswordInput] = useState(tempPass);
  const [confirmPasswordInput, setConfirmPasswordInput] = useState("");
  const [nameInput, setNameInput] = useState(name);
  const [lastNameInput, setLastNameInput] = useState(surname);
  const [cityInput, setCityInput] = useState("");
  const [refferalCodeInput, setRefferetialCodeInput] = useState("");

  ////////////////////////////////////////////////handle funkcije
  const handleAcceptRulesCheck = () => {
    dispatch(loginActions.resetRegisterError());
    setAcceptRules((prevstate) => !prevstate);
  };

  const handleAcceptDataProcessing = () => {
    dispatch(loginActions.resetRegisterError());
    setAcceptDataProcessing((prevstate) => !prevstate);
  };

  const handleAcceptNotifications = () => {
    dispatch(loginActions.resetRegisterError());
    setAcceptNotifications((prevstate) => !prevstate);
  };

  const handleAcceptOffers = () => {
    dispatch(loginActions.resetRegisterError());
    setAcceptOffers((prevstate) => !prevstate);
  };

  const handleEmailInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setEmailInput(e.target.value);
  };

  const handlePhoneNumberInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setPhoneNumberInput(e.target.value);
  };

  const handlePasswordInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setPasswordInput(e.target.value);
  };

  const handleConfirmPasswordInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setConfirmPasswordInput(e.target.value);
  };

  const handleNameInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setNameInput(e.target.value);
  };

  const handleLastNameInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setLastNameInput(e.target.value);
  };

  const handleRefferetialCodeInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setRefferetialCodeInput(e.target.value);
  };

  const handleCityInput = (e) => {
    dispatch(loginActions.resetRegisterError());
    setCityInput(e.target.value);
  };

  const handleCityInputDropdown = (v) => {
    dispatch(loginActions.resetRegisterError());
    setCityInput(v);
  };

  ////////////////////////////////////////////////METHODS

  const register = async () => {
    const response = await dispatch(
      asyncLoginActions.register({
        email: emailInput,
        password: passwordInput,
        mobile: phoneNumberInput,
        mobilePrefix: countryCode,
        confirmPassword: confirmPasswordInput,
        name: nameInput,
        surname: lastNameInput,
        refcode: refferalCodeInput,
        permission1: acceptRules,
        permission2: acceptDataProcessing,
        permission3: acceptNotifications,
        permission4: acceptOffers,
        townCity: cityInput,
        navigate: navigate,
        isWithSocialNetwork: isWithSocialNetwork,
        code: code,
        socialNetworkId: socialNetworkId,
        socialNetworkType: socialNetworkType
      })
    );
  };

  ////////////////////////////////////////////////EFFECTS

  useEffect(() => {
    const resPromise = dispatch(countriesAsyncActions.getCountries());
    return () => {
      resPromise.abort();
    };
  }, []);

  useEffect(() => {
    const resPromise = dispatch(citiesAsyncActions.getCities());
    return () => {
      resPromise.abort();
    };
  }, []);

  useEffect(() => {
    setCountryCode(countriesState.defCountryPhoneCode);
  }, [countriesState.defCountryPhoneCode]);

  /*
    clear errors on mount
  */
  useEffect(() => {
    dispatch(loginActions.resetRegisterError());
  }, []);

  ////////////////////////////////////////////////RENDER
  return (
    <LoginTemplate
      onEnter={register}
      heading={title}
      autoRelogin={autoRelogin}
      focusElement={emailRef}
      afterLoginRoutesPath={afterLoginRoutesPath}
    >
      
      <BaseInput
        type="email"
        placeholder="emailAdress"
        innerRef={emailRef}
        value={emailInput}
        onChange={handleEmailInput}
        readOnly={isWithSocialNetwork}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <div
          style={{
            flex: 1,
            marginRight: "3%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <BaseDropdown2
            includeNull
            placeholder={"countryCodeShortName"}
            readOnly={countriesState.lockPhoneCountryCode}
            translate={false}
            style={{ minWidth: "20px" }}
            value={countriesState.defCountryPhoneCode ? `${countryCode}` : ""}
            translateSufix
            elements={countriesState.countries.map((country) => {
              return {
                key: country.code,
                value: country.phone_code,
                name: `+${country.phone_code}`,
                optionSufix: country.translation_code,
              };
            })}
            onChange={(value) => {
              setCountryCode(value);
            }}
          />
        </div>
        <div style={{ flex: 4 }}>
          <BaseInput
            placeholder="phoneNumber"
            value={phoneNumberInput}
            onChange={handlePhoneNumberInput}
          />
        </div>
      </div>

      { isWithSocialNetwork === false && 
        <>
          <BaseInput
            type="password"
            placeholder="newPassword"
            value={passwordInput}
            onChange={handlePasswordInput}
          />
          <BaseInput
            type="password"
            placeholder="confirmNewPassword"
            value={confirmPasswordInput}
            onChange={handleConfirmPasswordInput}
          />
        </>
      }
      <BaseInput
        placeholder="name"
        value={nameInput}
        onChange={handleNameInput}
        readOnly={isWithSocialNetwork}
      />
      <BaseInput
        placeholder="lastName"
        value={lastNameInput}
        onChange={handleLastNameInput}
        readOnly={isWithSocialNetwork}
      />

      {/* ///////////////////////////////////////////////// */}

      {systemState.settings.req_town_city === true &&
        systemState.settings.fk_town_city === true && (
          <BaseDropdown2
            includeNull
            placeholder="chooseCity"
            elements={citiesState.cities.map((city) => {
              return {
                key: city.code,
                value: city.code,
                name: `${city.name}`,
              };
            })}
            onChange={handleCityInputDropdown}
            value={cityInput}
            translate
          />
        )}

      {systemState.settings.req_town_city === true &&
        systemState.settings.fk_town_city === false && (
          <BaseInput
            placeholder="chooseCity"
            value={cityInput}
            onChange={handleCityInput}
          />
        )}

      <BaseInput
        placeholder="refferalCode"
        value={refferalCodeInput}
        onChange={handleRefferetialCodeInput}
      />

      <ApplicationRulesCheckbox
        value={acceptRules}
        onChange={handleAcceptRulesCheck}
      />

      <br />
      <DataProcessingCheckbox
        value={acceptDataProcessing}
        onChange={handleAcceptDataProcessing}
      />
      <br />
      <NotificationsCheckbox
        value={acceptNotifications}
        onChange={handleAcceptNotifications}
      />

      <br />

      <OffersPromotionsCheckbox
        value={acceptOffers}
        onChange={handleAcceptOffers}
      />

      <BaseButton
        error={loginState.register.error.errorMsg}
        onClick={() => {
          register();
        }}
      >
        continue
      </BaseButton>
    </LoginTemplate>
  );
};

export default RegisterView;
